import i18n from "../i18n";

export const validateEmail = (email: string) =>
  /^\S+@\S+$/.test(email) ? null : i18n.t("validation.invalidEmail");
export const requiredField = (value) =>
  !value || (typeof value === "string" && value.trim() === "")
    ? i18n.t("validation.required")
    : null;
export const validatePhone = (value) =>
  !value || !value.isValid ? i18n.t("validation.invalidPhone") : null;
